/**
 * Central motion tokens — the single source of truth for animation timing
 * across the site. Components (Reveal, CountUp, AmbientVideo) and the CSS
 * motion layer in light-studio.css follow these values; when tuning motion,
 * change them here rather than per-component.
 *
 * All motion is a progressive enhancement gated by prefers-reduced-motion
 * (see useReducedMotion). Nothing here may hide content permanently.
 */

/** Standard ease-out curve (matches power3.out feel). */
export const EASE_OUT = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** Durations in ms. */
export const DURATION = {
  /** Micro interactions: hovers, button feedback. */
  fast: 200,
  /** Standard reveals and entrances. */
  base: 700,
  /** Stat counters and larger sweeps. */
  slow: 1200,
} as const;

/** Stagger steps in ms for sequential reveals. */
export const STAGGER = {
  /** Dense lists (deliverable chips, small cards). */
  tight: 60,
  /** Card grids. */
  card: 70,
} as const;

/** Cap sequential delays so long lists don't over-delay late items. */
export const MAX_STAGGER_STEPS = 6;

/** Default translate distance (px) for fade-up reveals. */
export const REVEAL_DISTANCE = 24;
